<script lang="ts">
  import type { Product } from "../stores/products";

  export let product: Product;
</script>

<div class="flex items-center space-x-8">
  <img
    src={product.image}
    alt={product.name}
    loading="lazy"
    class="w-20 h-20 object-contain"
  />

  <div>
    <div>
      <span class="text-lg font-bold">{product.name}</span>
    </div>

    {#if product.price}
      <div class="flex items-baseline space-x-4">
        <div>
          <span class="font-bold text-olli-500"
            >{@html product.price.before_tax}</span
          >
          <span class="text-gray-600">alv 0 %</span>
        </div>
        <div class="text-sm text-gray-500">
          <span class="font-bold">{@html product.price.after_tax}</span>
          <span>alv 24 %</span>
        </div>
      </div>
    {/if}

    {#if product.url}
      <a
        href={product.url}
        class="flex items-center text-sm text-gray-500 hover:text-olli-500"
        target="_blank"
      >
        <span>Lisätiedot</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="ml-[2px] pt-[1px] h-3 w-3"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
            clip-rule="evenodd"
          />
        </svg>
      </a>
    {/if}
  </div>
</div>
